import crystalBasinSource from "./crystal-basin-source.json";
import eastPassageSource from "./east-passage-source.json";
import echoVaultSource from "./echo-vault-source.json";
import shatteredReachSource from "./shattered-reach-source.json";
import { buildCavernMapConfig } from "./westPassageMapConfigs";

export const EAST_PASSAGE_MAP_CONFIG = buildCavernMapConfig(eastPassageSource);
export const CRYSTAL_BASIN_MAP_CONFIG = buildCavernMapConfig(crystalBasinSource);
export const ECHO_VAULT_MAP_CONFIG = buildCavernMapConfig(echoVaultSource);
export const SHATTERED_REACH_MAP_CONFIG =
  buildCavernMapConfig(shatteredReachSource);
